import Input from "./Input/Input";
import Select from "./Select/Select";
import TextArea from "./TextArea/TextArea";
import DateTime from "./DateTime/DateTime";
import Slider from "./Sider/Slider";
import Password from "./Password/Password";
import SubHeader from "./SubHeader/SubHeader";  // NEW
import Text from "./Text/Text";  // NEW
import RadioGroup from "./RadioGroup/RadioGroup";
import CheckBoxList from "./CheckBoxList/CheckBoxList";
import MultiSelectDropDown from "./MultiSelectDropDown/MultiSelectDropDown";
import DateOnly from "./Date/Date"

const FormType = {
  Input,
  Select,
  TextArea,
  DateTime,
  Slider,
  Password,
  SubHeader,   
  Text,        
  RadioGroup, 
  CheckBoxList, 
  MultiSelectDropDown, 
  DateOnly
};

export default FormType;
